import React from 'react';
import { Map, Check } from 'lucide-react';

/**
 * Компонент боковой панели с общими значениями и примерами
 */
const CommonValuesSidebar = ({ setFormData, unitDefinitions }) => {
  // Популярные расстояния для сравнения
  const commonDistances = [
    { 
      name: 'Красная площадь', 
      description: 'Длина Красной площади в Москве', 
      value: 330, 
      unit: 'm' 
    },
    { 
      name: 'Байкал', 
      description: 'Длина озера Байкал с севера на юг', 
      value: 636, 
      unit: 'km' 
    },
    { 
      name: 'Транссиб', 
      description: 'Длина Транссибирской магистрали', 
      value: 9288, 
      unit: 'km' 
    },
    { 
      name: 'Останкинская башня', 
      description: 'Высота Останкинской телебашни', 
      value: 540, 
      unit: 'm' 
    },
    { 
      name: 'Москва-Санкт-Петербург', 
      description: 'Расстояние между Москвой и Санкт-Петербургом', 
      value: 705, 
      unit: 'km' 
    },
    { 
      name: 'МКАД', 
      description: 'Длина Московской кольцевой автодороги', 
      value: 108.9, 
      unit: 'km' 
    },
    { 
      name: 'Марафон', 
      description: 'Стандартная длина марафонской дистанции', 
      value: 42.195, 
      unit: 'km' 
    },
    { 
      name: 'Футбольное поле', 
      description: 'Стандартная длина футбольного поля', 
      value: 105, 
      unit: 'm' 
    },
    { 
      name: 'Садовое кольцо', 
      description: 'Длина Садового кольца в Москве', 
      value: 15.6, 
      unit: 'km' 
    }
  ];

  // Обработчик выбора расстояния
  const handleDistanceSelect = (item) => {
    setFormData(prev => ({
      ...prev,
      fromValue: item.value.toString(),
      fromUnit: item.unit
    }));
  };
  
  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5 shadow-sm">
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <Map className="w-5 h-5 mr-2 text-green-500" />
        Примеры расстояний России
      </h3>
      
      <div className="space-y-2 max-h-[350px] overflow-y-auto pr-1 custom-scrollbar">
        {commonDistances.map((distance, index) => {
          const unitInfo = unitDefinitions[distance.unit];
          
          return (
            <button
              key={index}
              onClick={() => handleDistanceSelect(distance)}
              className="w-full text-left p-3 bg-gray-50 dark:bg-gray-700/50 hover:bg-green-50 dark:hover:bg-green-900/20 rounded-lg border border-gray-200 dark:border-gray-700 transition-colors focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-opacity-50"
            >
              <div className="flex items-start">
                <div className="mt-1 mr-3">
                  <Check className="w-4 h-4 text-green-500" />
                </div>
                <div>
                  <div className="font-medium text-gray-800 dark:text-gray-200">
                    {distance.name}
                  </div>
                  <div className="flex flex-wrap items-center gap-1 text-sm text-gray-600 dark:text-gray-400">
                    <span>{distance.description}</span>
                    <span className="font-medium text-green-600 dark:text-green-400">
                      {distance.value} {unitInfo?.shortName || distance.unit}
                    </span>
                  </div>
                </div>
              </div>
            </button>
          );
        })}
      </div>
      
      <div className="mt-4 p-3 bg-green-50 dark:bg-green-900/20 rounded-lg border border-green-100 dark:border-green-800">
        <p className="text-xs text-green-700 dark:text-green-300">
          Нажмите на любой пример, чтобы использовать его значение для конвертации. Это поможет вам получить представление о реальных масштабах.
        </p>
      </div>

      <style jsx>{`
        .custom-scrollbar::-webkit-scrollbar {
          width: 6px;
        }
        .custom-scrollbar::-webkit-scrollbar-track {
          background: #f1f1f1;
          border-radius: 10px;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb {
          background: #d1d5db;
          border-radius: 10px;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb:hover {
          background: #9ca3af;
        }
        .dark .custom-scrollbar::-webkit-scrollbar-track {
          background: #374151;
        }
        .dark .custom-scrollbar::-webkit-scrollbar-thumb {
          background: #4b5563;
        }
        .dark .custom-scrollbar::-webkit-scrollbar-thumb:hover {
          background: #6b7280;
        }
      `}</style>
    </div>
  );
};

export default CommonValuesSidebar;